import { sortBy } from 'lodash'
import { I18N_replaceNameSlugs } from '../I18N/I18N.slugs'
import { IDB_proceduresReadAll } from '../IDB/IDB.table.procedure'
import { pipe } from '../../../shared/lib/functional/pipe.no-deps'
import { filterAsync } from '../../../shared/lib/functional/array.no-deps'
import { IDB_procedures } from '../IDB/IDB.dexie'
import type { Procedure, SyncProcedure } from '../../../app-core/lib/procedure/Procedure'

export async function Proc_fetchAll() {
    return IDB_proceduresReadAll()
        .then(I18N_replaceNameSlugs)
        .then((procedures) => sortBy(procedures, 'name'))
}

export async function Proc_fetchExistingAssigned() {
    return pipe(await Proc_fetchAll(), filterAsync(Proc_isAssignedAndExisting))
}

export async function Proc_fetchExisting() {
    return pipe(await Proc_fetchAll(), filterAsync(Proc_exists))
}

/**
 * We have procedures from sync in the HIVE5.5.0 database (`IDB_proceduresReadAll()`)
 * And procedures from syncV2 in the zaptic database (`IDB_procedures()`)
 * The former have the workflows that a procedure has and the latter has whether it's currently
 * assigned or deleted. So if you want to know both you have to fetch both. This isn't ideal.
 */
export async function Proc_isAssignedAndExisting(procedure: Procedure) {
    // Return procedures which are assigned and not deleted
    return Proc_filter(procedure, (p) => p.isAssigned && !p.isDeleted)
}

function Proc_exists(procedure: Procedure) {
    // Return procedures which are not deleted
    return Proc_filter(procedure, (p) => !p.isDeleted)
}

function Proc_filter(procedure: Procedure, filterFn: (procedure: SyncProcedure) => boolean) {
    return IDB_procedures()
        .get(procedure.id)
        .then(filterFn)
        .catch(() => false)
}
